module.exports = __webpack_public_path__ + "static/media/pharmacy-man.6d110f80.png";